module.exports = __webpack_public_path__ + "static/media/default_exterior_background.81951bb1.svg";